/**
 * Admin sidebar modules. Used for:
 * - Building staff-allowed modules list (assignable to staff users)
 * - Filtering sidebar for staff by allowedModules
 */
export const ADMIN_MENU_ITEMS = [
  {
    key: 'users',
    label: 'Users',
    children: [
      { label: 'All users', path: '/admin/users' },
      { label: 'Teachers', path: '/admin/teachers' },
      { label: 'Students', path: '/admin/students' },
      { label: 'Progress', path: '/students/progress' },
      { label: 'Parents', path: '/admin/parents' },
      { label: 'Staff', path: '/admin/staff' }
    ]
  },
  {
    key: 'communication',
    label: 'Communication',
    children: [
      { label: 'Messages', path: '/messages' },
      { label: 'Meetings', path: '/meetings' },
      { label: 'Notifications', path: '/notifications' }
    ]
  },
  {
    key: 'content',
    label: 'Content',
    children: [
      { label: 'Question bank', path: '/questions' },
      { label: 'Exam settings', path: '/exam-settings' },
      { label: 'Games', path: '/admin/games' },
      { label: 'Syllabus', path: '/admin/syllabus' },
      { label: 'Past questions', path: '/admin/past-questions' },
      { label: 'AI questions', path: '/admin/ai-questions' }
    ]
  },
  {
    key: 'analytics',
    label: 'Analytics',
    children: [
      { label: 'Usage', path: '/admin/analytics' },
      { label: 'Performance', path: '/admin/performance' },
      { label: 'Activity', path: '/admin/activity' }
    ]
  },
  {
    key: 'referrals',
    label: 'Referrals',
    children: [
      { label: 'Overview', path: '/admin/referrals' },
      { label: 'Users', path: '/admin/referrals/users' },
      { label: 'Stats', path: '/admin/referrals/stats' },
      { label: 'QR codes', path: '/admin/referrals/qr' }
    ]
  },
  {
    key: 'rewards',
    label: 'Rewards',
    children: [
      { label: 'Overview', path: '/admin/rewards' },
      { label: 'History', path: '/admin/rewards/history' },
      { label: 'Analytics', path: '/admin/rewards/analytics' },
      { label: 'Settings', path: '/admin/rewards/settings' },
      { label: 'Airtime', path: '/admin/airtime/transactions' }
    ]
  },
  {
    key: 'system',
    label: 'Settings',
    children: [
      { label: 'General', path: '/admin/settings' },
      { label: 'Security', path: '/admin/security' },
      { label: 'Database', path: '/admin/database' },
      { label: 'API', path: '/admin/api' }
    ]
  }
];

/** Flattened list of { path, label } for staff module assignment (excludes staffOnly items) */
export const ADMIN_MODULES_FLAT = ADMIN_MENU_ITEMS.flatMap((section) =>
  (section.children || []).filter((c) => !c.staffOnly).map((c) => ({ path: c.path, label: c.label }))
);
